import generateHeaders from '@/resources/functions/generateHeaders';
import Log from '@/resources/plugins/Logger/Log';
import Service from '@/services/strapi/Service';

export default {
  async getInfos(params: { _sort: string }) {
    try {
      const response = await Service.get(`/infos`, {
        headers: generateHeaders('idToken', { Accept: 'application/json' }),
        params,
      });

      Log.debug('getInfos#Response', response);

      return response.data;
    } catch (error) {
      Log.error('getInfos#Error', error);

      throw error;
    }
  },
};
